/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import DescriptionIcon from '@mui/icons-material/Description';
import Filter1Icon from '@mui/icons-material/Filter1';
import PortraitIcon from '@mui/icons-material/Portrait';
import BuildIcon from '@mui/icons-material/Build';
import WorkIcon from '@mui/icons-material/Work';
import { User, Company } from './UserModel';

export interface LicenseData {
  licenseid: number,
  licensetype: LicenseType,
  machinename: string,
  user: User,
  company: Company,
  activationcode: ActivationCode,
  orderid?: string,
  licensestatus: 'Activated' | 'Unused' | 'AutoProvisioned',
  activationcount: number,
  subscription: Array<Subscription>
}

export interface LicenseType {
  typename: string
}


export interface ActivationCode {
  code: string
}

export interface Subscription {
  startdate: string,
  enddate: string
}

export const licenseSearchSuggestions = [
  {
    Icon: PortraitIcon,
    toolTip: 'User Name',
    suffix: ' in User Name',
    searchProp: 'username'
  },
  {
    Icon: WorkIcon,
    toolTip: 'Company Name',
    suffix: ' in Company Name',
    searchProp: 'company'
  },
  {
    Icon: BuildIcon,
    toolTip: 'Machine Name',
    suffix: ' in Machine Name',
    searchProp: 'machinename'
    },
    {
        Icon: PortraitIcon,
        toolTip: 'Email',
        suffix: ' in Email',
        searchProp: 'emailid'
    },
  //{
  //  Icon: MoneyIcon,
  //  toolTip: "Activation Code",
  //  suffix: " in Activation Code",
  //  searchProp: "code"
  //},
  {
    Icon: Filter1Icon,
    toolTip: 'License type',
    suffix: ' in License type',
    searchProp: 'licensetype'
  }
];

export const exportLicenseColumnAttributesPdf = {
  'Name': { halign: 'center', cellWidth: 70 },
  'Company Name': { halign: 'center', cellWidth: 120 },
  'Machine Name': { halign: 'center', cellWidth: 70 },
  'Activation Code': { halign: 'center', cellWidth: 60 },
  'Order ID': { halign: 'center', cellWidth: 60 },
  'License Status': { halign: 'center', cellWidth: 70 },
  'Activations': { halign: 'center', cellWidth: 50 },
  'Expiry Date': { halign: 'center', cellWidth: 70 }
}
;